import React, { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";

// Numbered, collapsible wizard card. Shared by Profile (Step 1) and Setup
// (Step 2) so both steps look and behave identically.
export default function StepCard({ index, title, Icon, accent = "#E2E30A", children, collapsible = false, defaultOpen = true, hint }) {
  const [open, setOpen] = useState(defaultOpen);
  // Sync when defaultOpen flips (e.g. newPlan() prefills after mount).
  useEffect(() => { setOpen(defaultOpen); }, [defaultOpen]);
  return (
    <section className="border border-white/10 bg-[#141414] relative min-w-0 overflow-hidden"
      style={{ boxShadow: `inset 3px 0 0 0 ${accent}` }}>
      <header
        className={`flex items-center gap-3 px-5 pt-4 pb-3 border-b border-white/5 ${collapsible ? "cursor-pointer select-none hover:bg-white/[0.02]" : ""}`}
        onClick={collapsible ? () => setOpen((o) => !o) : undefined}
        role={collapsible ? "button" : undefined}
        aria-expanded={collapsible ? open : undefined}
        data-testid={collapsible ? `step-card-toggle-${index}` : undefined}
      >
        <div className="h-7 min-w-[28px] px-1.5 grid place-items-center border font-display text-xs font-bold"
          style={{ color: accent, borderColor: accent }}>
          {index}
        </div>
        <Icon className="h-4 w-4" style={{ color: accent }} />
        <h3 className="font-display uppercase tracking-[0.15em] text-[13px] sm:text-sm text-white font-bold flex-1 min-w-0 leading-snug">{title}</h3>
        {collapsible && hint && !open && (
          <span className="text-[10px] uppercase tracking-wider text-zinc-400 hidden sm:inline truncate">{hint}</span>
        )}
        {collapsible && (
          <ChevronDown className={`h-4 w-4 text-zinc-400 shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
        )}
      </header>
      {(!collapsible || open) && <div className="p-5">{children}</div>}
    </section>
  );
}
